import { useCallback } from 'react';

import { CollapsibleBase, ActivityFilter, MainTabEnum } from '@rivallapp/volosports-components';
import toggleArrayItem from '../../../../../zustand-stores/DiscoverStore/utils/toggleArrayItem';
import useDiscoverStore, { DiscoverActions } from '../../../../../zustand-stores/DiscoverStore';
import { useUrlParams } from '../../../../../hooks';

const { updateFilterCollapsed } = DiscoverActions;

const DiscoverActivityFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const view = useDiscoverStore(store => store.view);
  const cityName = useDiscoverStore(store => store.filters.cityName);
  const selectedSportNames = useDiscoverStore(store => store.filters.selectedSportNames);
  const selectedSportNamesCollapsed = useDiscoverStore(
    store => store.filtersCollapsed.selectedSportNames
  );

  const onPressActivity = useCallback(
    activity => {
      updateUrlParams({ sportNames: toggleArrayItem(selectedSportNames, activity) });
    },
    [updateUrlParams, selectedSportNames]
  );

  const toggleFilterCollapsed = () =>
    updateFilterCollapsed('selectedSportNames', !selectedSportNamesCollapsed);

  const isRental = view === MainTabEnum.COURT_RENTALS;

  return (
    <CollapsibleBase
      isCollapsed={selectedSportNamesCollapsed}
      title="Sports"
      onPress={toggleFilterCollapsed}
    >
      <ActivityFilter
        isRental={isRental}
        cityName={cityName}
        onPress={onPressActivity}
        selectedActivities={selectedSportNames}
        view={view}
      />
    </CollapsibleBase>
  );
};

export default DiscoverActivityFilter;
